import {
  INITIAL_QUOTE,
  INITIAL_COLOURS_AND_EXTRAS
} from '../../utils/constants';

export default function () {
  return {
    displayQuoteAcceptance: false,
    privacyDocumentOpenedDate: undefined,
    privacyDocumentAcceptedDate: undefined,
    termsDocumentOpenedDate: undefined,
    termsDocumentAcceptedDate: undefined,
    leaseDocumentOpenedDate: undefined,
    leaseDocumentAcceptedDate: undefined,
    loadingQuote: false,
    quotePDFHref: undefined,
    loadingQuotePDF: false,
    savingQuote: false,
    acceptingQuote: false,
    routeQuoteId: undefined,
    quote: { ...INITIAL_QUOTE },
    dealersPrice: [],
    loadingColoursAndExtras: false,
    coloursAndExtras: { ...INITIAL_COLOURS_AND_EXTRAS }
  };
}
